/**
 * 앱 이름을 표시용으로 변환하는 함수
 * @param appname - 원본 앱 이름 (예: "smlink_M2_충청")
 * @returns 표시용 앱 이름 (예: "콜헌터")
 */
export const getDisplayAppName = (appname: string): string => {
  // "smlink_M2_" 제거
  const cleanName = appname.replace('smlink_M2_', '');
  
  // 특정 이름 변경
  switch (cleanName) {
    case '충청':
      return '콜헌터';
    case '서울b':
      return '서울-경기';
    default:
      return cleanName;
  }
};

/**
 * 앱 이름이 충청 앱인지 확인하는 함수
 * @param appname - 앱 이름
 * @returns 충청 앱 여부
 */
export const isChungcheongApp = (appname: string): boolean => {
  return appname === 'smlink_M2_충청';
};

/**
 * 앱 이름이 서울 앱인지 확인하는 함수
 * @param appname - 앱 이름
 * @returns 서울 앱 여부
 */
export const isSeoulApp = (appname: string): boolean => {
  return appname === 'smlink_M2_서울b';
}; 